export default __webpack_public_path__ + "static/media/Shivam Saxena.01a154c5.jpg";